module.exports = __webpack_public_path__ + "static/img/biotechnology_2.f40ecf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/biotechnology_2.png
// module id = NOX7
// module chunks = 6